module.exports = __webpack_public_path__ + "img/IMG_2547-2.22773510.jpg";